<template>
  <div class="lunchgate-panorama">
    <figure class="aspect-[3/2] bg-scheme-main-ter desktop:aspect-[2/1]">
      <ClientOnly>
        <iframe
          title="lunchgate-iframe"
          class="size-full"
          scrolling="no"
          loading="lazy"
          :src="src"
        />
      </ClientOnly>
    </figure>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  url: string
}>()

const { isMobile } = useViewport()

const desktopUrl = computed(() => props.url + '&w=auto&h=auto')
const mobileUrl = computed(() =>
  desktopUrl.value.replace('embed.php', 'mobilepano.php'),
)

const src = computed(() =>
  isMobile.value ? mobileUrl.value : desktopUrl.value,
)
</script>
